import React, { FC } from 'react'
import scrollTo from 'gatsby-plugin-smoothscroll'
import Button from '@material-ui/core/Button'

import StylesModule from 'components/lv1/ImageScrollButton.module.scss'

import UpArrow from 'images/icon_up_arrow.svg'

export interface ImageScrollButtonProps {
  target: string
  text: string
}

const ImageScrollButton: FC<ImageScrollButtonProps> = ({ target, text }) => {
  const link = `#${target}`
  return (
    <div className={'pb-16'}>
      <div className={StylesModule.imageScrollButton}>
        <Button
          color="primary"
          size="large"
          onClick={() => scrollTo(link)}
          classes={{
            root: StylesModule.imageScrollButton__button,
          }}
        >
          <img
            src={UpArrow}
            className={StylesModule.imageScrollButton__icon}
            area-hidden="true"
            alt=""
          />
          <div className={StylesModule.imageScrollButton__text}>{text}</div>
        </Button>
        <div className={StylesModule.imageScrollButton__bgCover}></div>
      </div>
    </div>
  )
}

export default ImageScrollButton
